import Cookies from "js-cookie";
import { getDomain } from ".";

export const API_USER = process.env.REACT_APP_API_USER;
export const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

export const API_URI = 'https://api.1gov.ng'; 
console.log('API_BASE_URL', process.env.REACT_APP_API_URI);

export const ACCESS_TOKEN_KEY = "access_token";

export const TOKEN = Cookies.get(ACCESS_TOKEN_KEY);

export enum MessageStatus {
  SENT,
  NOT_SENT,
}

export const allowedMimeTypes: string[] = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/png",
  "application/pdf"
]

export const maxFileSizeInMB = 8

export const fileSizeConversionRate=1024
